module.exports = __webpack_public_path__ + "img/alipay.f4d24ad1.png";